import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';
import { MessageOutput } from '../model/message.output';

export interface FetchMessageByIdParams {
	readonly id: string;
}

@Injectable({ providedIn: 'root' })
export class FetchMessageByIdApiQuery extends ApiQuery<
	MessageOutput,
	FetchMessageByIdParams
> {
	client = 'messaging';
	document = gql`
		query FetchMessageById($id: UUID!) {
			fetchMessageById(id: $id) {
				id
				content
				authorId
				moduleId
				documentId
				visioSessionId
				participantsId
				updateTimestamp
				creationTimestamp
			}
		}
	`;
	method = 'fetchMessageById';
}
